/* eslint eqeqeq: "off" */
import React, { useEffect, useState } from "react";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  // UserOutlined,
  DownOutlined,
  RightOutlined,
  DashboardFilled,
  LogoutOutlined,
  WhatsAppOutlined,
  UsergroupAddOutlined,
} from "@ant-design/icons";
// import Logo from "../../assets/images/sidebar-logo.png";
import Logo from "../../assets/images/admin-logo-2.png";
import LogoIcon from "../../assets/images/admin-logo-3.png";
// import Logo from "../../assets/images/logo-main.png";
// import SidebarLogo from "../../assets/images/logo.png";
import PropTypes from "prop-types";
import { useHistory, withRouter } from "react-router-dom";
import {
  Button,
  Layout,
  // Divider,
  theme,
  Typography,
  FloatButton,
  Image,
} from "antd";
import { Link } from "react-router-dom";
import "./index.css";
// import { isEmpty } from "lodash";
import toast, { Toaster } from "react-hot-toast";
import useMedia from "use-media-antd-query";
// import { useDispatch } from "react-redux";
// import { loadOrganizationList } from "../../store/organisation/actions";
// import api from "../../helpers";
import { RiOrganizationChart } from "react-icons/ri";
import { FaTicket } from "react-icons/fa6";
import { MdAccessibility } from "react-icons/md";
import { FaBell, FaRegBell } from "react-icons/fa";

import { BiShield } from "react-icons/bi";



const { Header, Content, Footer, Sider } = Layout;

const menuList = [
  {
    key: "general",
    label: "General",
  },
  {
    key: "dashboard",
    label: "Dashboard",
    pathname: "/dashboard",
    // children: [],
    icon: <DashboardFilled />,
  },
  {
    key: "manageOrganization",
    label: "Manage Organization",
    pathname: "/manage-organization",
    icon: <RiOrganizationChart className="text-[18px]" />,
  },
  {
    key: "userManagements",
    label: "User Managements",
  },
  {
    key: "access",
    label: "Access",
    pathname: "/user/access",
    icon: <MdAccessibility />,
  },
  // {
  //   key: "automatedBills",
  //   label: "Automated Bills",
  //   pathname: "/automated-bills",
  //   icon: <FaPiggyBank />,
  // },
  {
    key: "menu",
    label: "Menu",
    pathname: "/user/menu",
    icon: <MenuUnfoldOutlined />,
  },
  {
    key: "userRole",
    label: "User Role",
    pathname: "/user/role",
    icon: <UsergroupAddOutlined className="text-[16px]" />,
  },
  {
    key: "userPermission",
    label: "User Permission",
    pathname: "/user/permission",
    icon: <BiShield className="text-[16px]" />,
  },

  {
    key: "support",
    label: "Support",
  },
  {
    key: "ticketing",
    label: "Ticketing",
    pathname: "/ticketing",
    icon: <FaTicket className="text-[18px]" />,
  },
    {
    key: "notifications",
    label: "Notifications",
  },
  {
    key: "pushNotification",
    label: "Push Notification",
    pathname: "/push-notification",
    icon: <FaBell className="text-[18px]"/> 
  },
  {
    key: "inAppNotification",
    label: "In App Notification",
    pathname: "/in-app-notification",
    icon: <FaRegBell className="text-[18px]" />,
  },
];

// const profileDetails = (
//   <div className="hover:rounded-md hover:mr-[-3px] hover:bg-black-200 flex justify-between w-[170px] cursor-pointer">
//     <div className="text-start mt-1">
//       <Link
//         to={{
//           pathname: "/profile",
//           state: { row: "", data: "login" },
//         }}
//       >
//         <p className="flex text-[14px] font-label font-medium">
//           <UserOutlined className="mr-2" /> Profile
//         </p>
//       </Link>
//       <Divider className="w-[264%] mt-[8px] mb-[8px] ml-[-10px]" />
//       <p className="flex text-[14px] font-label font-medium">
//         <Link
//           to={{
//             pathname: "/login",
//             state: { row: "", data: "login" },
//           }}
//           onClick={() => {
//             localStorage.setItem("accountDetails", "");
//             localStorage.setItem("userDetails", "");
//             localStorage.setItem("loginToken", "");
//             localStorage.setItem("authToken", "");
//             localStorage.setItem("user", "");
//             localStorage.setItem("authData", "");
//             localStorage.setItem("organizationDetails", "");
//           }}
//         >
//           <LogoutOutlined className="mr-2" /> Logout
//         </Link>
//       </p>
//     </div>
//   </div>
// );

const LayoutMain = (props) => {
  const [collapsed, setCollapsed] = useState(false);
  // const [createPagesList, setCreatePagesList] = useState(false);
  const [subMenuSelected, setSubMenuSelected] = useState("");
  const [globalMenu, setGlobalMenu] = useState("");
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  // const { organization_list = [] } = useSelector((state) => state.Organisation);
  const media = useMedia();
  //values from login response
  // const userName = localStorage.getItem("authData");

  useEffect(() => {
    if (media === "md" || media === "sm" || media === "xs") {
      setCollapsed(true);
    } else {
      setCollapsed(false);
    }
  }, [media]);

  //values from login response end

  const menuPath = props && props.location ? props.location.pathname : "";

  // window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  // const [downloadLoading, setDownloadLoading] = useState(false);

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // const dispatch = useDispatch();
  const history = useHistory();

  // useEffect(() => {

  //   //eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  return (
    <React.Fragment>
      <Layout
        style={{
          padding: "6px",
        }}
      >
        <Sider
          collapsible
          width={240}
          trigger={null}
          theme={"dark"}
          // onScroll={true}
          collapsedWidth={75}
          collapsed={collapsed}
          style={{
            borderRadius: "10px",
            marginRight: "4px",
            overflow: "hidden",
            height: "100%",
            position: "fixed",
            boxShadow: "#dbdbdb 0px 3px 6px 3px",
            transition: collapsed
              ? "all 800ms ease-in-out"
              : "all 800ms ease-in-out",
            opacity: 20,
            // scrollBehavior: "unset",
            border: "2px solid #001529",
          }}
          // onCollapse={(value) => setCollapsed(value)}
        >
          <>
            <div
              style={{
                padding: "2px",
                height: windowDimensions.height > 800 ? "7%" : "10%",
                display: "flex",
                flexDirection: "column",
                marginLeft: collapsed ? "-5px" : "0px",
              }}
            >
              <div className={"flex sidebar-header mb-[30px]"}>
                <div className="w-[100%] flex justify-center">
                  {collapsed ? (
                    <Image
                      src={LogoIcon}
                      preview={false}
                      height={38}
                      width={40}
                      // width={collapsed ? 180 : 205}
                    />
                  ) : (
                    <Image
                      src={Logo}
                      preview={false}
                      height={40}
                      width={148}
                      // width={collapsed ? 180 : 205}
                    />
                  )}
                </div>
              </div>
            </div>

            <div
              className={
                windowDimensions.height > 800
                  ? "scroll-layout h-[85%]"
                  : "scroll-layout h-[78%]"
              }
            >
              {menuList.length > 0 &&
                menuList.map((data, index) => {
                  const subMenuPath =
                    data &&
                    data.children &&
                    data.children.length > 0 &&
                    menuPath
                      ? data.children.find(
                          (subMenu) => subMenu.pathname == menuPath
                        )
                      : "";
                  const subMenuPathName = subMenuPath && subMenuPath.pathname;
                  return (
                    <div key={index} className="mb-2 pl-2.5 pr-2.5">
                      {/* <div key={index} className="mt-2 mb-2 pl-2.5 pr-2.5"> */}
                      <Link
                        onClick={() => {
                          if (
                            data.label === "General" ||
                            data.label === "User Managements" || data.label === "Support"
                          ) {
                            setGlobalMenu("");
                          }
                          if (data.label) {
                            setGlobalMenu(data.label);
                          } else {
                            setGlobalMenu(data.label);
                          }
                          if (
                            subMenuSelected === data.label &&
                            data.children &&
                            data.children.length > 0
                          ) {
                            setSubMenuSelected("");
                          } else {
                            setSubMenuSelected(data.label);
                          }
                        }}
                        to={{
                          pathname: data.pathname,
                        }}
                        className={
                          // globalMenu === data.label ||
                          menuPath == data.pathname
                            ? "flex justify-between text-[#ffffff] sidebar-header-list font-medium bg-[#4399e9bf] p-2 rounded-2xl"
                            : data.label === "General" ||
                              data.label === "User Managements" ||
                              data.label === "Support"
                            ? "flex justify-between text-[lightgray] sidebar-header-list font-medium p-2 rounded-2xl"
                            : "flex justify-between text-[lightgray] sidebar-header-list font-medium hover:bg-[#7b6f6fb0] p-2 rounded-2xl"
                        }
                      >
                        {data.label === "General" ||
                        data.label === "User Managements" ||
                        data.label === "Support" ? (
                          <div className="mb-[-6px]">
                            <h1
                              className={
                                collapsed
                                  ? "ml-[-16px] uppercase text-[10px] text-[#ffffff]"
                                  : "ml-[-3px] uppercase text-[10px] text-[#ffffff]"
                              }
                            >
                              {data.label}
                            </h1>
                          </div>
                        ) : (
                          <div className="flex">
                            <p className="mr-2">{data.icon}</p>
                            {collapsed ? (
                              ""
                            ) : (
                              <h1
                                className={
                                  data.label === "Expenses" ? "mt-[-2px]" : ""
                                }
                              >
                                {data.label}
                              </h1>
                            )}
                          </div>
                        )}
                        {(subMenuPathName !== undefined &&
                          menuPath === subMenuPathName &&
                          data.children &&
                          data.children.length > 0) ||
                        (subMenuSelected === data.label &&
                          data.children &&
                          data.children.length > 0) ? (
                          <DownOutlined
                            className="mt-1"
                            onClick={() => {
                              setSubMenuSelected("");
                            }}
                          />
                        ) : data.children && data.children.length > 0 ? (
                          <RightOutlined
                            className="mt-1"
                            onClick={() => {
                              setSubMenuSelected(data.label);
                            }}
                          />
                        ) : (
                          ""
                        )}{" "}
                      </Link>
                      <div className="ml-2 mt-2 bg-[#181717] rounded-lg">
                        {(subMenuPathName !== undefined &&
                          menuPath === subMenuPathName) ||
                        (subMenuSelected == data.label &&
                          data.children &&
                          data.children.length > 0)
                          ? // ||
                            // (menuPath == data.pathname &&
                            //   data.children &&
                            //   data.children.length > 0) ||
                            // (data.children &&
                            //   data.children.length > 0 &&
                            //   subMenuPath &&
                            //   subMenuPath.pathname == menuPath)
                            data.children.map((subMenu, index) => {
                              return (
                                <div
                                  onClick={() => {
                                    setGlobalMenu(subMenu.label);
                                  }}
                                  key={index}
                                >
                                  <Link
                                    to={{
                                      pathname: subMenu.pathname,
                                    }}
                                    className={
                                      globalMenu === subMenu.label ||
                                      menuPath === subMenu.pathname
                                        ? "flex text-[10px] text-[#ffffff] sidebar-header-list font-medium bg-[#4399e9bf] p-1 pl-2 pb-2 pt-2 mb-2 rounded-2xl"
                                        : "flex text-[10px] text-[lightgray] sidebar-header-list font-medium hover:bg-[#7b6f6fb0] p-1 pl-2 pb-2 pt-2 mb-2 rounded-2xl"
                                    }
                                  >
                                    <p className="text-[12px] mr-2 mt-1 hover:text-[#ffffff]">
                                      {subMenu.icon}
                                    </p>
                                    {collapsed ? (
                                      ""
                                    ) : (
                                      <h1 className="text-[12px] hover:text-[#ffffff">
                                        {subMenu.label}
                                      </h1>
                                    )}
                                  </Link>
                                </div>
                              );
                            })
                          : ""}
                      </div>
                    </div>
                  );
                })}
            </div>

            <div
              className={
                windowDimensions.height > 800
                  ? "sidebar-settings-main h-[8%]"
                  : "sidebar-settings-main h-[12%]"
              }
            >
              <div className="w-[100%] hover:text-[#3498db] flex justify-center">
                <div
                  // to={{
                  //   pathname: "/login",
                  //   state: { row: "", data: "login" },
                  // }}
                  onClick={() => {
                    localStorage.setItem("loginToken", "");
                    localStorage.setItem("authToken", "");
                    toast.success("Logged out successfully");
                    setTimeout(() => {
                      history.push("/login");
                    }, 800);
                  }}
                  style={{
                    border: "1px solid #414141cf",
                  }}
                  className="cursor-pointer flex justify-center hover:text-[#3498db] p-2 rounded-md shadow-lg mt-3 w-[45%]"
                >
                  <LogoutOutlined style={{ fontSize: 16, cursor: "pointer" }} />
                  {!collapsed ? (
                    <div className="flex pl-2 pr-2">
                      <h1 className="uppercase font-label text-[11px] hover:text-[#3498db] ml-1 text-[white] font-semibold">
                        Logout
                      </h1>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {/* {!collapsed ? (
                <div
                  className={
                    windowDimensions.height > 1000
                      ? "flex justify-center mt-7"
                      : "flex justify-center mt-3"
                  }
                >
                  <div className="flex space-evenly mt-3 ml-4">
                  <Typography className="font-label text-[#a3a3a3] text-[9px]">
                    <SafetyCertificateOutlined className="mx-1" /> 100% secure
                  </Typography>
                  <Typography className="font-label mx-4 text-start text-[#a3a3a3] text-[9px]">
                      <BankOutlined className="mx-1" />
                      ISO 27001 Certified
                    </Typography>
                </div>
              ) : (
                ""
              )} */}
            </div>
          </>
        </Sider>
        <Layout
          className={collapsed ? "pl-[85px]" : "pl-[245px]"}
          style={{
            transition: collapsed
              ? "all 800ms ease-in-out"
              : "all 800ms ease-in-out",
          }}
        >
          <Header
            style={{
              padding: 0,
              background: colorBgContainer,
              textAlign: "start",
              display: "flex",
              flexDirection: "row",
              borderRadius: "",
              justifyContent: "space-between",
            }}
          >
            <Button
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed(!collapsed)}
              style={{
                fontSize: "16px",
                width: 64,
                height: 64,
              }}
            />
            {/* <Popover
              trigger={"click"}
              placement="bottom"
              content={profileDetails}
              className="w-[200px] h-[40px] mt-4 mr-6 border border-gray-100 rounded-md"
            >
              <div className="flex justify-between ">
                <div className="flex pl-2 pr-2">
                  <Avatar
                    style={{
                      backgroundColor: "#8400ff",
                      marginTop: "8px",
                      textTransform: "capitalize",
                    }}
                    size={"small"}
                  >
                     <Image
                    src={Logo}
                    style={{ borderRadius: "50%" }}
                    height={20}
                    width={20}
                  /> {" "}
                    {!isEmpty(userInfoDetails) && userNameAvatar
                      ? userNameAvatar
                      : !isEmpty(profileName) && profileNameAvatar
                      ? profileNameAvatar
                      : ""}
                  </Avatar>{" "}
                  <h1 className="uppercase mt-[-12px] text-[12px] ml-1 text-[black] font-semibold">
                    {!isEmpty(userInfoDetails)
                      ? userInfoDetails
                      : !isEmpty(profileName)
                      ? profileName
                      : ""}
                  </h1>
                </div>
                <DownOutlined className="cursor-pointer pl-2 pr-2" />
              </div>
            </Popover> */}
          </Header>
          <Content
            style={{
              borderRadius: "8px",
            }}
          >
            <div
              style={{
                padding: "8px 2px",
                textAlign: "start",
                // height: "400px",
              }}
              className={
                menuPath === "/reports-dashboard"
                  ? "content-layout bg-[white] mt-2"
                  : "content-layout"
              }
            >
              {props.children}
            </div>
          </Content>
          <Footer
            style={{
              textAlign: "center",
              position: "sticky",
              top: "4px",
              bottom: 0,
              display: "flex",
              height: "50px",
              background: "#f1f1f1",
              alignItems: "center",
              justifyContent: "space-between",
              fontFamily: "sans-serif",
            }}
          >
            <Typography
              style={{
                fontFamily: "Poppins",
              }}
              className="text-[12px]"
            >
              MBook ©{new Date().getFullYear()}
            </Typography>
            <Typography
              style={{
                fontFamily: "Poppins",
              }}
              className="text-[12px]"
            >
              Created by Mequals Technologies
            </Typography>
          </Footer>
          {/* )} */}
        </Layout>
        <Toaster containerClassName="text-[13px] font-label font-semibold" />
        <FloatButton
          className="w-[50px] h-[50px]"
          type="primary"
          style={{
            margin: "-31px -14px",
          }}
          onClick={() => {
            window.open("https://wa.me/919894998818");
          }}
          icon={<WhatsAppOutlined />}
        />
      </Layout>
    </React.Fragment>
  );
};

LayoutMain.propTypes = {
  children: PropTypes.object,
  location: PropTypes.object,
};
export default withRouter(LayoutMain);
